import type { RacePageDataTransferObject } from '@mobi/api-types/racePage/types'
import type ObservableRacePage from '../Model/Observables/ObservableRacePage'

export default {
  map(dto: RacePageDataTransferObject, model: ObservableRacePage) {
    for (const element of dto.AvailableBetTypes) {
      model.addBetType(element)
    }
  },
}
